import { Component, Directive, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { InvoicesService } from '../services/invoices.service';
import { environment } from '../../environments/environment';
import { BillingPortalProps } from '../models/BillingPortalProps';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReusableErrorComponent } from '../shared/popup/reusable-error-component/reusable-error.component';
import { BansStorageService } from '../services/bans-storage.service';

interface IPaymentHistory {
  banNo: string;
  transactionId: string;
  currency: string;
  amount: number;
  paymentDate: string;
  invoiceDate: string;
  paymentType: string
}

export type SortColumn = keyof IPaymentHistory | '';
export type SortDirection = 'asc' | 'desc' | '';

const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };
const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

export interface SortEvent {
  column: SortColumn;
  direction: SortDirection;
}

@Directive({
  selector: 'th[sortable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '(click)': 'rotate()'
  }
})
export class NgbdSortableHeader {

  @Input() sortable: SortColumn = '';
  @Input() direction: SortDirection = '';
  @Output() sort = new EventEmitter<SortEvent>();

  rotate() {
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortable, direction: this.direction });
  }
}
@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.css'],
})

export class PaymentHistoryComponent implements OnInit {

  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  @ViewChild(ReusableErrorComponent) errorPopup!: ReusableErrorComponent;

  banflag: boolean = false;
  customerIDs: Array<string> = [];
  paymentHistory: Array<IPaymentHistory> = [];
  AllpaymentHistory: Array<IPaymentHistory> = [];
  banCAs = new Map<string, Array<string>>();
  bans: Array<string> = [];
  cano: Array<string> = [];
  bansList: any = []
  isLoading = false;
  currentPage = 1;
  itemsPerPage = environment.itemsPerPage;
  isAllPaymentHistoryLoaded: boolean = true;
  ban: string = "";
  selectedPaymentData: any;
  showPMInfoLoader: boolean = false;
  bansForTSA: any = [];
  unSupportedBanPM: boolean = false;
  instructionTextForPopup: string = "";
  banResponse : any;
  BillingPortalProps: BillingPortalProps = new BillingPortalProps();
  toggleLoading = () => this.isLoading = !this.isLoading;
  isSledCustomer: boolean = false;

  constructor(
    private invoicesService: InvoicesService,
    private http: HttpClient,
    private bansService: BansStorageService
  ) { }

  async ngOnInit(): Promise<void> {
    this.getBans();
  }

  getBans() {
    this.bansService.bans.subscribe((bans: any) => {
      this.bansService.bansTSA.subscribe((bansTSA: any) => {
        if (bansTSA) {
          this.bansForTSA = bansTSA;
        }
      })
      this.bansService.bansApiResponse.subscribe((bansResponse: any) => {
        if (bansResponse) {
          this.banResponse = bansResponse;
        }
      })
      if (bans) {
        this.banCAs = bans;
        let ban = JSON.parse(JSON.stringify(localStorage.getItem("Selected_BAN_Dropdown_Value"))) || "";
        let banCA = JSON.parse(JSON.stringify(localStorage.getItem("Selected_BAN_CAs_Dropdown")));
        let firstBAN: any = this.banCAs.entries().next().value;
        this.ban = ban ? ban : firstBAN[0];
        let selectedBANCA = banCA ? banCA : firstBAN[1];
        var sledBan = this.banResponse && this.banResponse.find((x: { bancust: string; }) => x.bancust == this.ban) || { zzachclass_bus: "", contractacc: "" };
        this.isSledCustomer = sledBan.zzachclass_bus == 'SLED';
        this.getPaymentHistory(this.ban, selectedBANCA);
      }
      else {
        this.bansService.banFlag.subscribe(
          (isPresent: boolean) => {
            if (!isPresent) {
              this.AllpaymentHistory = []
              this.paymentHistory = [];
              this.unSupportedBanPM = true;
            }
          });
      }
    })
  }

  selectedBan() {
    if (this.ban != "BAN") {
      const selectedBan = this.banCAs.get(this.ban) || [""];
      this.getPaymentHistory(this.ban, selectedBan);
    }
  }

  async getPaymentHistory(bpno: any, cano: any) {
    this.paymentHistory = []
    this.banflag = false;
    let filteredBAN = this.bansForTSA.filter((element: any) => { return (element.bancust == bpno) });
    if (filteredBAN.length && !filteredBAN[0].isSamevkTyp && environment.tsaErrorPopupVisibility) {
      this.showErrorScreen();
      return;
    }
    this.unSupportedBanPM = false;
    cano = filteredBAN.length && filteredBAN[0].isTSA ? filteredBAN[0].contractacc : cano;
    (await this.invoicesService
      .getPaymentHistoryNew(bpno, cano))
      .subscribe((res: any) => {
        res.forEach((element: any) => {
          let totalAmount = 0;
          if (element.PaymMethod == 'CARD PAYMENT' && !this.isSledCustomer) {
            totalAmount = Math.abs(Number.parseFloat(element.PaymentAmnt)) + 8.95;
          }
          else {
            totalAmount = Math.abs(Number(element.PaymentAmnt));
          }
          var data = {
            banNo: element.BusPartner,
            transactionId: element.DocNumber,
            currency: element.TransCurrency,
            amount: Math.abs(Number.parseFloat(element.PaymentAmnt)),
            paymentDate: element.DocDate,
            invoiceDate: element.DocDate,
            paymentStatus: element.Status,
            paymentType: element.PaymMethod,
            totalAmount: totalAmount,
            confirmationCode: element.ConfirmCode,
            paymentMethod: 'NA'
          }
          if (this.paymentHistory.findIndex((item) => item.transactionId === data.transactionId) < 0) {
            this.paymentHistory.push(data);
          }
        });
        this.paymentHistory = this.paymentHistory.sort((a: any, b: any) => {
          return <any>new Date(b.paymentDate).getTime() - <any>new Date(a.paymentDate).getTime();
        });
        this.AllpaymentHistory = this.paymentHistory;
        this.paymentHistory = this.AllpaymentHistory.slice(0, this.itemsPerPage);
        this.banflag = true;
        this.resetLoadMoreButton();
        console.log(this.paymentHistory)
      });
  }

  loadMorePaymentHistory = () => {
    if (this.paymentHistory.length < this.AllpaymentHistory.length) {
      this.appendData();
    } else if (this.paymentHistory.length === this.AllpaymentHistory.length) {
      this.isAllPaymentHistoryLoaded = true;
    }
  }

  appendData() {
    this.paymentHistory = [...this.AllpaymentHistory];
    this.resetLoadMoreButton();
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    if (direction === '' || column === '') {
      this.paymentHistory = this.AllpaymentHistory.slice(0, this.paymentHistory.length);
    } else {
      this.AllpaymentHistory = [...this.AllpaymentHistory].sort((a, b) => {
        if (column.toLocaleLowerCase().includes("date")) {
          if (direction === 'asc')
            return new Date(b[column]).getTime() - new Date(a[column]).getTime();
          else
            return new Date(a[column]).getTime() - new Date(b[column]).getTime();
        } else {
          const res = compare(a[column], b[column]);
          return direction === 'asc' ? res : -res;
        }
      });
      this.paymentHistory = this.AllpaymentHistory.slice(0, this.paymentHistory.length);
    }
  }

  selectBan(selectedBan: string): void {
    this.ban = selectedBan;
    if (this.ban != "BAN") {
      var sledBan = this.banResponse && this.banResponse.find((x: { bancust: string; }) => x.bancust == this.ban) || { zzachclass_bus: "", contractacc: "" };
      this.isSledCustomer = sledBan.zzachclass_bus == 'SLED';
      const selectedBan = this.banCAs.get(this.ban) || [""];
      this.getPaymentHistory(this.ban, selectedBan);
    }
  }

  resetLoadMoreButton() {
    if (this.paymentHistory.length === this.AllpaymentHistory.length) {
      this.isAllPaymentHistoryLoaded = true;
    } else {
      this.isAllPaymentHistoryLoaded = false;
    }
  }

  downloadCSV() {
    if (this.AllpaymentHistory.length) {
      let data = this.makeCSV(this.AllpaymentHistory);
      this.fileDownload(data);
    }
  }

  fileDownload(data: any) {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', `${this.ban}-Payment-History.csv`);
    a.click();
  }

  makeCSV(data: any) {
    const columnMapping: { [key: string]: string } = {
        banNo: "BAN Number",
        transactionId: "Transaction ID",
        currency: "Currency",
        amount: "Amount",
        paymentDate: "Payment Date",
        invoiceDate: "Invoice Date",
        paymentStatus: "Payment Status",
        paymentType: "Payment Type",
        totalAmount: "Total Amount",
        confirmationCode: "Confirmation Code",
        paymentMethod: "Payment Method"
    };
    const headers = Object.keys(columnMapping);
    const csvContent = [];
    csvContent.push(Object.values(columnMapping).join(','));
    data.forEach((item: any) => {
        const row: any = headers.map(header => {
            let value = item[header] ?? '';
            if (typeof value === 'string' && value.includes(',')) {
                value = `"${value}"`;
            }
            return value;
        });
        csvContent.push(row.join(','));
    });
    return csvContent.join('\n');
  }

  openPaymentDetails(data: any) {
    if (this.selectedPaymentData == data) {
      this.selectedPaymentData = {}
      return;
    }
    if (data.confirmationCode) {
      this.paymentDetails(data);
    }
    this.selectedPaymentData = data;
  }

  async paymentDetails(paymentData: any) {
    let payloadData = {
      "confirmationcode": paymentData.confirmationCode,
      "creditAccount": this.ban
    }
    this.showPMInfoLoader = true;
    let logTraceJSON: any = { 'eventSource': 'getPaymentDetails', 'payload': payloadData, 'ban': this.ban, 'confirmationCode': paymentData.confirmationCode };
    const headers = new HttpHeaders({
        'X-Log-Trace': JSON.stringify(logTraceJSON),
    });
    this.http.post(environment.serverURL + environment.pgURI + 'mm-payment/payment-info', payloadData, {headers}).subscribe(
      (res: any) => {
        if (res) {
          this.showPMInfoLoader = false;
          this.selectedPaymentData.paymentMethod = res.truncatedDda ? res.truncatedDda : res.cardNumber;
        }
      }, (error: any) => {
        console.log(error);
        this.showPMInfoLoader = false;
        this.selectedPaymentData.paymentMethod = 'NA';
      });
  }

  showErrorScreen() {
    this.AllpaymentHistory = []
    this.paymentHistory = [];
    this.unSupportedBanPM = true;
    this.instructionTextForPopup = "There is some issue with your account, please contact support team.";
    this.errorPopup && this.errorPopup.showPopup();
  }

  formatPaymentData(input: any) {
    const formattedInput = input.slice(-4);
    return '**** ' + formattedInput;
  }
}
